var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInfoColored(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 29.014,
    height: 29.014,
    viewBox: "0 0 29.014 29.014",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_4682",
    "data-name": "Group 4682",
    transform: "translate(-368 -1327)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2657",
    "data-name": "Path 2657",
    d: "M29.014,0H0V29.014H29.014Z",
    transform: "translate(368 1327)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2656",
    "data-name": "Path 2656",
    d: "M12.206,12.206l.046-.022a.837.837,0,0,1,1.186.951l-.79,3.165a.837.837,0,0,0,1.186.952l.046-.023m9.206-4.185A10.043,10.043,0,1,1,13.043,3,10.043,10.043,0,0,1,23.086,13.043ZM13.043,8.859h.009v.009h-.009Z",
    transform: "translate(370.022 1329.022)",
    fill: "#afb4c5",
    stroke: "#f5f6fb",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoColored);
export default __webpack_public_path__ + "static/media/info_colored.6affdc3a76b5f6539396526c1ab25e86.svg";
export { ForwardRef as ReactComponent };